import { DialogVariants          } from 'src/components/common/dialog';
import { OneActionDialogVariants } from 'src/components/common/one-action-dialog';



type RSODHelpDialogLookAndFeel = {
  dialogVariant: DialogVariants;
  oneActionVarint: OneActionDialogVariants;
}

const rsodhelpdialog_light: RSODHelpDialogLookAndFeel = {
  dialogVariant: 'light',
  oneActionVarint: 'light',
}

export type RSODHelpDialogVariants = 'light';

export const rsodhelpdialog_variants: Map<RSODHelpDialogVariants, RSODHelpDialogLookAndFeel> = 
  new Map<RSODHelpDialogVariants, RSODHelpDialogLookAndFeel>([
    ['light', rsodhelpdialog_light],
  ]);
